import { Wire, WireType } from '@treasury/domain/wires';
import { TmBaseComponent } from '@treasury/presentation';
import { css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import './wire-data-editable';

export const tagName = 'wire-create-step';
@customElement(tagName)
export class WireCreateStep extends TmBaseComponent {
    @property()
    public wireType = WireType.Domestic;

    @state()
    private wire?: Wire;

    @state()
    private wireId = '';

    @state()
    private validWire = false;

    protected render() {
        return html`<wire-data-editable
                .wire=${this.wire}
                .wireType=${this.wireType}
                .wireId=${this.wireId}
                @update=${(e: CustomEvent) => {
                    this.wire = e.detail;
                    this.checkWireValidity();
                }}
            ></wire-data-editable>
            <tm-footer
                .buttonConfig=${[
                    {
                        text: 'Review',
                        disabled: !this.validWire,
                        onClick: () => {
                            this.dispatchEvent(new CustomEvent('review', { detail: this.wire }));
                        },
                    },
                ]}
            ></tm-footer>`;
    }

    private checkWireValidity() {
        if (this.wire) {
            this.validWire =
                !!this.wire.beneficiary.accountNumber &&
                !!this.wire.wireCompany?.id &&
                !!this.wire.debitAccount?.id &&
                this.wire.amount > 0 &&
                !!this.wire.purpose?.length;
        }
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: block;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: WireCreateStep;
    }
}
